import styled from 'styled-components';
import fonts from '../../ui/fonts';

import { colors } from '../../ui/design-tokens/index';
import { space, media, rems } from '../../ui/helpers';
import { BREAKPOINTS } from '../../ui/settings';

const Container = styled.nav`
  border-top: 1px solid ${colors.neutral[800]};
  display: flex;
  justify-content: center;
  flex-flow: column;
  padding: ${space(7)} 0 0 0;

  .column {
    width: calc(25% - ${space(8)});
    min-width: calc((${rems(BREAKPOINTS.mainwrapper)} - ${space(16)}) / 4);
    max-width: calc((${rems(BREAKPOINTS.mainwrapper)} - ${space(12)}) / 4);

    ${media.max('xlarge')`
      &:last-child {
        padding-left: 0;
      }
    `}

    padding: 0;
    margin-bottom: ${space(4)};

    .label {
      ${fonts.bodyLGHighlights};
      margin-bottom: ${space(3)};
      color: ${colors.neutral[400]};
    }

    &:last-child {
      margin-bottom: 0;
    }

    ul {
      li {
        margin-bottom: ${space(3)};

        a {
          color: ${colors.neutral[100]};

          &:hover,
          &:active {
            color: ${colors.primary[100]};
          }
        }
      }
    }
  }

  ${media.min('medium')`
    padding: ${space(4)} 0 0;
    justify-content: flex-start;
    flex-flow: row wrap;

    .column {  
      padding: 0 ${space(3)};
      margin-bottom: ${space(6)};
      
      &:first-child {
        padding-left:0;
      }

      ul {
        li {
            margin-bottom: ${rems(12)};
        }
      }
    }
  `};
`;

export { Container };
